import * as i0 from "@angular/core";
/**
 * Coordinates an HDMI picture-in-picture overlay with playlist playback.
 *
 * The default implementation is a no-op: only platforms that actually drive an HDMI PiP window
 * (Tizen) override it. See the Tizen `PipControlService` for the real behavior.
 */
var PipControlServiceBase = /** @class */ (function () {
    function PipControlServiceBase() {
    }
    /**
     * Prepares the PiP for the content about to play and returns whether the caller must restart the
     * layout (stop + re-prepare) for this transition. No-op default returning false; platforms with
     * an HDMI PiP overlay override it.
     */
    PipControlServiceBase.prototype.prepareForContent = function (_type) {
        return Promise.resolve(false);
    };
    PipControlServiceBase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PipControlServiceBase_Factory() { return new PipControlServiceBase(); }, token: PipControlServiceBase, providedIn: "root" });
    return PipControlServiceBase;
}());
export { PipControlServiceBase };
